import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowTitle = _resolveComponent("WindowTitle")!
  const _component_ChangingNumber = _resolveComponent("ChangingNumber")!
  const _component_Green = _resolveComponent("Green")!
  const _component_Red = _resolveComponent("Red")!
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-systems" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowTitle, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Systems ")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, " Reactor output ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ChangingNumber, {
                        min: 27.1,
                        max: 27.2,
                        precision: 2
                      }),
                      _cache[1] || (_cache[1] = _createTextVNode(" GW "))
                    ]),
                    _: 1,
                    __: [1]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, " Attitude control ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("ONLINE")
                    ])),
                    _: 1,
                    __: [3]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, " Orbit change ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("SCHEDULED")
                    ])),
                    _: 1,
                    __: [5]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", null, " Life support ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("ONLINE")
                    ])),
                    _: 1,
                    __: [7]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", null, " Pool on the roof ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Red, null, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("LEAKING")
                    ])),
                    _: 1,
                    __: [9]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[12] || (_cache[12] = _createElementVNode("td", null, " Isopod colony ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("NOMINAL")
                    ])),
                    _: 1,
                    __: [11]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[14] || (_cache[14] = _createElementVNode("td", null, " Dome ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Green, null, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("BANGING")
                    ])),
                    _: 1,
                    __: [13]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[16] || (_cache[16] = _createElementVNode("td", null, " Puerto Rico ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Red, null, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("OFFENSIVE")
                    ])),
                    _: 1,
                    __: [15]
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}